import { createStore, createEffect } from "effector";

export interface IRoutePoint {
  arrivalDateByMonitoring: string;
  calculatedArrivalTime: string;
  completionDate: string;
  departureDateByMonitoring: string;
  driverNote: string;
  isCanceled: boolean;
  isDone: boolean;
  isDoneByMonitoring: boolean;
  pointAddress: string;
  pointId: string;
  reasonOfCancel: string;
}

export interface IRoute {
  distanceBetweenGarbageCarAndNextPoint: number;
  distanceBetweenPoints: number;
  garbageCarId: string;
  garbageCarNextPointId: string;
  garbageCarNumber: string;
  garbageCarPreviousPointId: string;
  isGarbageCarWentPolygon: boolean;
  garbageCollectionPoints: IRoutePoint[];
}

export const $routes = createStore<IRoute[]>([]);

export const queryRoutes = createEffect<void, IRoute[]>();

$routes.on(queryRoutes.doneData, (_, val) => val);

queryRoutes.use(() =>
  fetch("https://izba.kras-abs.ru/api/v2/getRoutes", { //Только крк
    method: "POST",
    body: JSON.stringify({}),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  })
    .then((res) => res.json())
    .then((res) => {
      let routes = res.table as IRoute[];
      return routes;
    })
);

export const getRouteIdxByPointId = (routes: IRoute[], pointId: string) => {
  for (let ri = 0, rlen = routes.length; ri < rlen; ri++) {
    let points = routes[ri].garbageCollectionPoints;
    for (let pi = 0, plen = points.length; pi < rlen; pi++) {
      if (pointId === points[pi].pointId) return ri;
    }
  }
  return -1;
};
